<template>
    <div v-if="user !== null">
        <div>
        <iframe
            ref="hiddenIframe_c0"
            name="hiddenIframe_c0"
            style="display: none;"
        ></iframe>
        <form
            ref="hidden_cdn_getcookies_c0"
            :action="cdn_postUrl_c0"
            method="POST"
            target="hiddenIframe_c0"
            style="display: none;"
        >
            <input type="hidden" name="token" :value="user.token" />
            <input type="hidden" name="route" value="c0" />
        </form>
        </div>

        <div>
        <iframe
            ref="hiddenIframe_c0ns"
            name="hiddenIframe_c0ns"
            style="display: none;"
        ></iframe>
        <form
            ref="hidden_cdn_getcookies_c0ns"
            :action="cdn_postUrl_c0ns"
            method="POST"
            target="hiddenIframe_c0ns"
            style="display: none;"
        >
            <input type="hidden" name="token" :value="user.token" />
            <input type="hidden" name="route" value="c0ns" />
        </form>
        </div>

        <div>
        <iframe
            ref="hiddenIframe_c0p"
            name="hiddenIframe_c0p"
            style="display: none;"
        ></iframe>
        <form
            ref="hidden_cdn_getcookies_c0p"
            :action="cdn_postUrl_c0p"
            method="POST"
            target="hiddenIframe_c0p"
            style="display: none;"
        >
            <input type="hidden" name="token" :value="user.token" />
            <input type="hidden" name="route" value="c0p" />
        </form>
        </div>

        <div>
        <iframe
            ref="hiddenIframe_s0p"
            name="hiddenIframe_s0p"
            style="display: none;"
        ></iframe>
        <form
            ref="hidden_cdn_getcookies_s0p"
            :action="cdn_postUrl_s0p"
            method="POST"
            target="hiddenIframe_s0p"
            style="display: none;"
        >
            <input type="hidden" name="token" :value="user.token" />
            <input type="hidden" name="route" value="s0p" />
        </form>
        </div>

        <div>
        <iframe
            ref="hiddenIframe_s0"
            name="hiddenIframe_s0"
            style="display: none;"
        ></iframe>
        <form
            ref="hidden_cdn_getcookies_s0"
            :action="cdn_postUrl_s0"
            method="POST"
            target="hiddenIframe_s0"
            style="display: none;"
        >
            <input type="hidden" name="token" :value="user.token" />
            <input type="hidden" name="route" value="s0" />
        </form>
        </div>

        <div>
        <iframe
            ref="hiddenIframe_s1"
            name="hiddenIframe_s1"
            style="display: none;"
        ></iframe>
        <form
            ref="hidden_cdn_getcookies_s1"
            :action="cdn_postUrl_s1"
            method="POST"
            target="hiddenIframe_s1"
            style="display: none;"
        >
            <input type="hidden" name="token" :value="user.token" />
            <input type="hidden" name="route" value="s1" />
        </form>
        </div>

        <div>
        <iframe
            ref="hiddenIframe_s0f"
            name="hiddenIframe_s0f"
            style="display: none;"
        ></iframe>
        <form
            ref="hidden_cdn_getcookies_s0f"
            :action="cdn_postUrl_s0f"
            method="POST"
            target="hiddenIframe_s0f"
            style="display: none;"
        >
            <input type="hidden" name="token" :value="user.token" />
            <input type="hidden" name="route" value="s0f" />
        </form>
        </div>

        <div>
        <iframe
            ref="hiddenIframe_s2"
            name="hiddenIframe_s2"
            style="display: none;"
        ></iframe>
        <form
            ref="hidden_cdn_getcookies_s2"
            :action="cdn_postUrl_s2"
            method="POST"
            target="hiddenIframe_s2"
            style="display: none;"
        >
            <input type="hidden" name="token" :value="user.token" />
            <input type="hidden" name="route" value="s2" />
        </form>
        </div>

        <div>
        <iframe
            ref="hiddenIframe_s3"
            name="hiddenIframe_s3"
            style="display: none;"
        ></iframe>
        <form
            ref="hidden_cdn_getcookies_s3"
            :action="cdn_postUrl_s3"
            method="POST"
            target="hiddenIframe_s3"
            style="display: none;"
        >
            <input type="hidden" name="token" :value="user.token" />
            <input type="hidden" name="route" value="s3" />
        </form>
        </div>

        <div>
        <iframe
            ref="hiddenIframe_trackNS"
            name="hiddenIframe_trackNS"
            style="display: none;"
        ></iframe>
        <form
            ref="hidden_cdn_getcookies_trackNS"
            :action="cdn_postUrl_trackNS"
            method="POST"
            target="hiddenIframe_trackNS"
            style="display: none;"
        >
            <input type="hidden" name="token" :value="user.token" />
            <input type="hidden" name="trackpath" :value="this.trackpath_NS" />
        </form>
        </div>

        <div>
        <iframe
            ref="hiddenIframe_trackSTREAM"
            name="hiddenIframe_trackSTREAM"
            style="display: none;"
        ></iframe>
        <form
            ref="hidden_cdn_getcookies_trackSTREAM"
            :action="cdn_postUrl_trackSTREAM"
            method="POST"
            target="hiddenIframe_trackSTREAM"
            style="display: none;"
        >
            <input type="hidden" name="token" :value="user.token" />
            <input type="hidden" name="trackpath" :value="this.trackpath_STREAM" />
        </form>
        </div>

        <div>
        <iframe
            ref="hiddenIframe_delete_c0ns"
            name="hiddenIframe_delete_c0ns"
            style="display: none;"
        ></iframe>
        <form
            ref="hidden_cdn_getcookies_delete_c0ns"
            :action="cdn_postUrl_delete_c0ns"
            method="POST"
            target="hiddenIframe_delete_c0ns"
            style="display: none;"
        >
            <input type="hidden" name="token" :value="user.token" />
            <input type="hidden" name="trackpath" :value="this.trackpath_DEL" />
            <input type="hidden" name="creatorid" :value="this.creatrorid_DEL" />
            <input type="hidden" name="route" value="c0ns" />
        </form>
        </div>

        <div>
        <iframe
            ref="hiddenIframe_delete_c0"
            name="hiddenIframe_delete_c0"
            style="display: none;"
        ></iframe>
        <form
            ref="hidden_cdn_getcookies_delete_c0"
            :action="cdn_postUrl_delete_c0"
            method="POST"
            target="hiddenIframe_delete_c0"
            style="display: none;"
        >
            <input type="hidden" name="token" :value="user.token" />
            <input type="hidden" name="trackpath" :value="this.trackpath_DEL" />
            <input type="hidden" name="creatorid" :value="this.creatrorid_DEL" />
            <input type="hidden" name="route" value="c0" />
        </form>
        </div>

        <div>
        <iframe
            ref="hiddenIframe_delete_s1"
            name="hiddenIframe_delete_s1"
            style="display: none;"
        ></iframe>
        <form
            ref="hidden_cdn_getcookies_delete_s1"
            :action="cdn_postUrl_delete_s1"
            method="POST"
            target="hiddenIframe_delete_s1"
            style="display: none;"
        >
            <input type="hidden" name="token" :value="user.token" />
            <input type="hidden" name="trackpath" :value="this.trackpath_DEL" />
            <input type="hidden" name="creatorid" :value="this.creatrorid_DEL" />
            <input type="hidden" name="route" value="s1" />
        </form>
        </div>

        <div>
        <iframe
            ref="hiddenIframe_delete_s2"
            name="hiddenIframe_delete_s2"
            style="display: none;"
        ></iframe>
        <form
            ref="hidden_cdn_getcookies_delete_s2"
            :action="cdn_postUrl_delete_s2"
            method="POST"
            target="hiddenIframe_delete_s2"
            style="display: none;"
        >
            <input type="hidden" name="token" :value="user.token" />
            <input type="hidden" name="trackpath" :value="this.trackpath_DEL" />
            <input type="hidden" name="creatorid" :value="this.creatrorid_DEL" />
            <input type="hidden" name="route" value="s2" />
        </form>
        </div>

        <div>
        <iframe
            ref="hiddenIframe_delete_s3"
            name="hiddenIframe_delete_s3"
            style="display: none;"
        ></iframe>
        <form
            ref="hidden_cdn_getcookies_delete_s3"
            :action="cdn_postUrl_delete_s3"
            method="POST"
            target="hiddenIframe_delete_s3"
            style="display: none;"
        >
            <input type="hidden" name="token" :value="user.token" />
            <input type="hidden" name="trackpath" :value="this.trackpath_DEL" />
            <input type="hidden" name="creatorid" :value="this.creatrorid_DEL" />
            <input type="hidden" name="route" value="s3" />
        </form>
        </div>

    </div>
  </template>
  
  <script>
import { done } from 'nprogress';

  
  export default {
    setup() {

    },
    data() {
      return {  
        cdn_postUrl_c0: "https://c0.muzible.com/api/v1/getcookies",
        cdn_postUrl_c0ns: "https://c0ns.muzible.com/api/v1/getcookies",
        cdn_postUrl_c0p: "https://c0p.muzible.com/api/v1/getcookies",
        cdn_postUrl_s0p: "https://s0p.muzible.com/api/v1/getcookies",
        cdn_postUrl_s0: "https://s0.muzible.com/api/v1/getcookies",
        cdn_postUrl_s1: "https://s1.muzible.com/api/v1/getcookies",
        cdn_postUrl_s0f: "https://s0f.muzible.com/api/v1/getcookies",
        cdn_postUrl_s2: "https://s2.muzible.com/api/v1/getcookies",
        cdn_postUrl_s3: "https://s3.muzible.com/api/v1/getcookies",

        cdn_postUrl_trackNS: "https://c0ns.muzible.com/api/v1/getcookiesfortrackNS",
        cdn_postUrl_trackSTREAM: "https://c0.muzible.com/api/v1/getcookiesfortrackSTREAM",

        cdn_postUrl_delete_c0ns: "https://c0ns.muzible.com/api/v1/deletecookies",
        cdn_postUrl_delete_c0: "https://c0.muzible.com/api/v1/deletecookies",
        cdn_postUrl_delete_s1: "https://s1.muzible.com/api/v1/deletecookies",
        cdn_postUrl_delete_s2: "https://s2.muzible.com/api/v1/deletecookies",
        cdn_postUrl_delete_s3: "https://s3.muzible.com/api/v1/deletecookies",

        trackpath_NS: "",
        trackpath_STREAM: "",

        creatrorid_DEL: "",
        trackpath_DEL: "",
      };
    },
    computed: {
      user() {
        return this.$store.getters.getUserData;
      },
    },
    methods: {


    },
    watch: {},
    created() {
    },
    mounted() {
        this.emitter.on("getcookies", ({route, done}) => {
            // Mapowanie ścieżek na referencje
            const routeMap = {
                "c0": this.$refs.hidden_cdn_getcookies_c0,
                "c0ns": this.$refs.hidden_cdn_getcookies_c0ns,
                "c0p": this.$refs.hidden_cdn_getcookies_c0p,
                "s0p": this.$refs.hidden_cdn_getcookies_s0p,
                "s0": this.$refs.hidden_cdn_getcookies_s0,
                "s1": this.$refs.hidden_cdn_getcookies_s1,
                "s0f": this.$refs.hidden_cdn_getcookies_s0f,
                "s2": this.$refs.hidden_cdn_getcookies_s2,
                "s3": this.$refs.hidden_cdn_getcookies_s3,
            };

            const routeIframe = {
                "c0": this.$refs.hiddenIframe_c0,
                "c0ns": this.$refs.hiddenIframe_c0ns,
                "c0p": this.$refs.hiddenIframe_c0p,
                "s0p": this.$refs.hiddenIframe_s0p,
                "s0": this.$refs.hiddenIframe_s0,
                "s1": this.$refs.hiddenIframe_s1,
                "s0f": this.$refs.hiddenIframe_s0f,
                "s2": this.$refs.hiddenIframe_s2,
                "s3": this.$refs.hiddenIframe_s3,
            }

            const ref = routeMap[route];
            const ref_if = routeIframe[route];
            ref_if.addEventListener("load", () => {
                done();
            });

            ref.submit();
        });
  
        this.emitter.on("getcookiesfortrackNS", ({track, done}) => {
            // format "CREATORID/TRACKID"
            this.trackpath_NS = track;
            const ref_if = this.$refs.hiddenIframe_trackNS;
            ref_if.addEventListener("load", () => {
                done();
            });

            this.$refs.hidden_cdn_getcookies_trackNS.submit();
        });  

        this.emitter.on("getcookiesfortrackSTREAM", ({track, done}) => {
            // format "CREATORID/TRACKID"
            this.trackpath_STREAM = track;
            const ref_if = this.$refs.hiddenIframe_trackSTREAM;
            ref_if.addEventListener("load", () => {
                done();
            });
            
            this.$refs.hidden_cdn_getcookies_trackSTREAM.submit();
        });  

        this.emitter.on("deletecookies", ({route, track, creator}) => {
            // format "CREATORID/TRACKID"
            // format "CREATORID"
            // route format: c0ns, c0, s1, s2, s3
            this.trackpath_DEL = track;
            this.creatrorid_DEL = creator;
            switch (route) {
                case "c0ns":
                    this.$refs.hidden_cdn_getcookies_delete_c0ns.submit();
                    break;
                case "c0":
                    this.$refs.hidden_cdn_getcookies_delete_c0.submit();
                    break;
                case "s1":
                    this.$refs.hidden_cdn_getcookies_delete_s1.submit();
                    break;
                case "s2":
                    this.$refs.hidden_cdn_getcookies_delete_s2.submit();
                    break;
                case "s3":
                    this.$refs.hidden_cdn_getcookies_delete_s3.submit();
                    break;
            }
        });  
    },

  };
  </script>
  
  <style lang="scss">
  @use "/src/views/css/styles.scss";

  </style>
  